import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=a9a3a712&scoped=true&"
import script from "./card-list.vue?vue&type=script&lang=ts&"
export * from "./card-list.vue?vue&type=script&lang=ts&"
import style0 from "./card-list.vue?vue&type=style&index=0&id=a9a3a712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a3a712",
  null
  
)

export default component.exports